module.exports = __webpack_public_path__ + "img/Xingqi_Chen-1-500x500.5bb6ea5d.png";